import {
  viewOffset,
  withinViewBounds,
  calculateRealLocation
} from "../../canvas/geometry";
import store from "../../store";

export default {
  methods: {
    refImgLocation(x, y) {
      const offset = viewOffset(this.refSize, this.refFit);
      if (!withinViewBounds(x, y, this.refSize, offset))
        return { x: -1, y: -1 };
      let loc = calculateRealLocation(x, y, offset, this.transform);
      return { x: loc.x / this.refFit.w, y: loc.y / this.refFit.h };
    },
    previousSlice() {
      store.dispatch("selectPreviousSliceCompare", this.name);
    },
    nextSlice() {
      store.dispatch("selectNextSliceCompare", this.name);
    },
    play() {
      store.dispatch("playSlicesCompare", this.name);
    },
    pause() {
      store.commit("pauseCompare", this.name);
    },
    setPlayRate(rate) {
      store.commit("setPlayRateCompare", { view: this.name, rate });
    },
    selectSlice(index) {
      store.dispatch("selectOCTImageByIndexCompare", {
        keyword: "slice",
        index,
        view: this.name
      });
    },
    wheel(e) {
      if (e.deltaY > 0) this.previousSlice();
      else this.nextSlice();
    }
  },
  computed: {
    octDataLoading() {
      return this.context && this.context.octDataLoading;
    },
    referenceImage() {
      return this.context && this.context.referenceImage;
    },
    refImgLoading() {
      return (
        this.referenceImage &&
        (this.referenceImage.imgIsLoading || this.referenceImage.imgIsQueued)
      );
    },
    refImgNotFound() {
      return !!(this.referenceImage && this.referenceImage.imgNotFound);
    },
    refImg() {
      return this.referenceImage && this.referenceImage.imgHtmlObject;
    },
    slices() {
      if (!this.context) return [];
      return store.getters.getSlices(
        "slice",
        this.context.exSrNo,
        this.context.groupName
      );
    },
    sliceBounds() {
      return this.context && this.context.sliceBounds;
    },
    isPlaying() {
      return !!(this.context && this.context.playIntervalId);
    },
    playRate() {
      return this.context && this.context.playRate;
    },
    sliceCurrent() {
      return this.context && this.context.sliceCurrent;
    },
    sliceCurrentIndex() {
      return this.sliceCurrent && this.sliceCurrent.index;
    },
    sliceCurrentEyeMarker() {
      return this.sliceCurrent && this.sliceCurrent.eyeMarker;
    },
    sliceImg() {
      return this.sliceCurrent && this.sliceCurrent.imgHtmlObject;
    },
    sliceImgSize() {
      return this.context && this.context.sliceImgSize;
    },
    sliceImgNotFound() {
      return !!(this.sliceCurrent && this.sliceCurrent.imgNotFound);
    },
    sliceImgLoading() {
      return (
        this.sliceCurrent &&
        (this.sliceCurrent.imgIsLoading || this.sliceCurrent.imgIsQueued)
      );
    },
    sliceInfo() {
      return this.context && this.context.sliceInfo;
    },
    hasSegmentation() {
      return this.sliceInfo && this.sliceInfo.sliceHasSegmentation;
    },
    showSegmentation() {
      return this.context && this.context.showSegmentation;
    },
    showOverlay() {
      return this.context && this.context.showOverlay;
    },
    overlayOpacity() {
      return this.context && this.context.overlayOpacity;
    },
    showETDRS() {
      return this.context && this.context.showETDRS;
    },
    colorSettings() {
      return this.context && this.context.octColorSettings;
    },
    hasColorPalette() {
      return this.colorSettings && !!this.colorSettings.colorPalette;
    },
    isInverted() {
      return this.colorSettings && this.colorSettings.isInverted;
    },
    sliceSegmentationLayerData() {
      return this.sliceCurrent && this.sliceCurrent.sliceSegmentationLayerData;
    },
    thicknessMapPalette() {
      return this.context && this.context.thicknessMapPalette;
    },
    minThickness() {
      return this.context && this.context.thicknessMapMinThicknessUm;
    },
    maxThickness() {
      return this.context && this.context.thicknessMapMaxThicknessUm;
    },
    thicknessStep() {
      return this.context && this.context.thicknessMapThicknessStepUm;
    },
    thicknessMap() {
      return this.context && this.context.thicknessMap;
    },
    thicknessMapImg() {
      return this.thicknessMap && this.thicknessMap.imgHtmlObject;
    },
    thicknessMapImgNotFound() {
      return !!(this.thicknessMap && this.thicknessMap.imgNotFound);
    },
    thicknessMapImgLoading() {
      return (
        this.thicknessMap &&
        (this.thicknessMap.imgIsLoading || this.thicknessMap.imgIsQueued)
      );
    },
    thicknessMapColorSettings() {
      return this.context && this.context.thicknessMapColorSettings;
    },
    foveaOffset() {
      return this.context && this.context.foveaOffset;
    },
    thicknessAnalysis() {
      return this.context && this.context.thicknessAnalysis;
    },
    enfaceImage() {
      return this.context && this.context.enfaceImage;
    },
    enfaceImg() {
      return this.enfaceImage && this.enfaceImage.imgHtmlObject;
    },
    differencePalette() {
      return this.context && this.context.differenceMapPalette;
    },
    differenceMin() {
      return this.context && this.context.differenceMapMinThicknessUm;
    },
    differenceMax() {
      return this.context && this.context.differenceMapMaxThicknessUm;
    },
    differenceStep() {
      return this.context && this.context.differenceMapThicknessStepUm;
    },
    differenceAnalysis() {
      return this.context && this.context.differenceAnalysis;
    },
    isCompare() {
      return this.name === "compare";
    },
    showDifferenceMap() {
      return this.isCompare && store.getters.comparisonSameType;
    },
    differenceCanvas() {
      return this.context && this.context.differenceCanvas;
    },
    overlayImg() {
      return this.showDifferenceMap ? this.differenceCanvas : this.enfaceImg;
    },
    overlayPalette() {
      return this.showDifferenceMap ? this.differencePalette : null;
    },
    overlayMin() {
      return this.showDifferenceMap ? this.differenceMin : null;
    },
    overlayMax() {
      return this.showDifferenceMap ? this.differenceMax : null;
    },
    overlayStep() {
      return this.showDifferenceMap ? this.differenceStep : null;
    },
    overlayFoveaOffset() {
      return this.showDifferenceMap ? this.foveaOffset : null;
    },
    overlayAnalysis() {
      return this.showDifferenceMap ? this.differenceAnalysis : null;
    },
    relativeMapSize() {
      return this.context && this.context.relativeMapSize;
    }   
  }
}